import { attributionSettingsSchema } from "@redotech/redo-attribution-common/attribution-settings";
import * as z from "zod";

export const getAttributionSettings = {
  name: "getAttributionSettings" as const,
  input: z.object({}),
  output: attributionSettingsSchema,
};
